<template>
  <div class="themeItem_leagueTable_container">
    <div class="tableScrollArea" ref="tableParentDom">
      <nodeTree_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="themeItem.renderTable.isScrollFlag"
        :variableColWidthVw="themeItem.renderTable.variableColWidthVw"
        :tableCellDefaultWidthVw="themeItem.renderTable.tableCellDefaultWidthVw"
        :defaultWidthVwNum="themeItem.renderTable.defaultWidthVwNum"
        :tableColumnData="themeItem.renderTable.tableColumnData"
        :tableData="themeItem.renderTable.tableData"
        :isBroadCastList="true"
        :tableHeightPx="tableHeightPx"
        v-show="themeItem && themeItem.renderTable.tableData.length > 0"
        :tableMode="tableMode"
        :rowClassName="tableRankLineArr ? rowClassNameFun : null"
      ></nodeTree_table>
      <!-- <p class="noDataClass" v-show="noData">暂无数据</p> -->
    </div>
  </div>
</template>

<script>
// 球队排名 主题  【支持竖向滚动】
import cup_base_data_mixin from '@mixins/cup_base_data'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
export default {
  name: 'themeItem_leagueTable_container',
  mixins: [cup_base_data_mixin],
  components: {
    nodeTree_table,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    themeRowClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableMode: 'combat_groupStage none',
      parentWidthPx: 0,
      themeItem: null,
      tableRankLineArr: null,
    }
  },
  computed: {
    tableHeightPx() {
      // 等比的，所以固定写死
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375
      return Math.floor((clientWidth / 100) * (2.638 * 5.4 + 3.332))
      //   return 'auto'
    },
  },
  created() {
    console.debug('this.datas:', this.datas)
    this.themeItem = this.computedTableData(this.datas)
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.$nextTick(() => {
      this.onResizeEvent()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
        console.debug('dom 存在')
        // this.tableHeightPx = this.$refs.tableParentDom.offsetHeight
      } else {
        console.debug('dom 不存在')
      }
      console.debug('this.tableHeightPx:', this.tableHeightPx)
    },
    rowClassNameFun({ row, rowIndex }) {
      // console.debug("rowClassNameFun:", row,rowIndex)
      var className = ''
      this.tableRankLineArr.forEach((lineNum, lineIndex) => {
        if (lineIndex === 0 && rowIndex < lineNum) {
          if (lineNum - 1 === rowIndex) {
            className =
              'basketballLeague_teamRank borderBottom rankNumSubColor1_1'
          } else {
            className = 'basketballLeague_teamRank rankNumSubColor1_1'
          }
        } else {
          if (lineNum - 1 === rowIndex) {
            className += ' basketballLeague_teamRank borderBottom'
          }
        }
      })
      return className
    },
    computedTableData(item) {
      let table_header = null

      const table = item
      let label = ''
      let tableData = []
      if (item.graphicsId === 2001) {
        this.tableRankLineArr = table.data.riseLine
        let statisticsModels = JSON.parse(JSON.stringify(item.statisticsModels))
        table_header = statisticsModels ? statisticsModels : null
        tableData = table.data.dataList
          ? table.data.dataList.map((team) => {
              team.teamId = team.teamId
              team.rankNum = team.groupRank
              team.teamName = team.teamName
              team.teamLogo = team.teamLogo
              if (team.lastSix) {
                if (team.lastSix.length > 5) {
                  team.teamRank_lastFive_record = team.lastSix.substring(0, 5)
                } else {
                  team.teamRank_lastFive_record = team.lastSix
                }
              }

              return team
            })
          : []
        label =
          tableData && tableData[0] && tableData[0].groupName
            ? tableData[0].groupName
            : '球队'
      }

      let otherTableColumnData = []
      if (table_header) {
        otherTableColumnData = table_header.map((keyItem) => {
          if (keyItem.statisticalEn === 'lastSix') {
            return {
              prop: 'teamRank_lastFive_record',
              label: keyItem.name,
              widthVw: 9,
            }
          } else {
            return {
              prop: keyItem.statisticalEn,
              label: keyItem.name,
              widthVw: 5.55,
            }
          }
        })
      }

      const tableColumnData = [].concat(
        [
          {
            prop: 'rankNum-teamLogo-teamName',
            label,
            widthVw: 25.42,
            className: 'columnNumLogoNameClass',
            fixed: 'left',
          },
        ],
        otherTableColumnData
      )

      item.renderTable = {
        isScrollFlag: false,
        variableColWidthVw: 20.83, // 可变化的宽度
        tableCellDefaultWidthVw: 5.55, // 默认宽度 ,
        defaultWidthVwNum: otherTableColumnData.length,
        tableColumnData,
        tableData: tableData,
        analysisItemId: table.analysisItemId,
        json: table.json,
        seasonOrMatch: table.seasonOrMatch,
        title: table.title,
      }

      return item
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.themeItem_leagueTable_container {
  width: 100%;
  padding: 0.694vw 0;
  .tableScrollArea {
    width: 100%;
  }
}
</style>
